import { render } from "./ThesisList.vue?vue&type=template&id=44452a50&ts=true"
import script from "./ThesisList.vue?vue&type=script&lang=ts"
export * from "./ThesisList.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__